import { useNavigate } from "react-router-dom";
import "../Blogs/Blogs";
import { allBlogs } from "../../utils/Constant";


export default function BlogSection({ title, subTitle, blogData=allBlogs }) {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate(path);
  };

  return (
    <section id="blogs" className="bg-white pt-5 pb-3">
      <div className="container">
        <h2 className="text-center display-6 fw-bold mb-3">
          {title ?? "Blogs"}
        </h2>

        <p className="text-body-secondary fw-normal fs-4 text-center mb-5">
          {subTitle ??
            "Explore engaging articles covering tech, development tips, and digital insights. Stay updated with the latest trends, tutorials, and guides to boost your knowledge and creativity."}
        </p>

        <div className="row g-4">
          {blogData?.map((blog) => (
            <div key={blog.id} className="col-md-4 d-flex">
              <div
                className="blog-card flex-fill d-flex flex-column p-3"
                onClick={() => handleNavigate(blog.path)}
              >
                <div className="blog-image mb-3">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="img-fluid rounded-3"
                  />
                </div>

                <h3 className="fw-bold fs-4">{blog.title}</h3>
                <p className="text-body-secondary fw-medium flex-grow-1">
                  {blog.description}
                </p>

                <div className="mt-auto text-end">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleNavigate(blog.path);
                    }}
                    className="btn btn-outline-primary btn-sm fw-semibold px-3 rounded-3"
                  >
                    <div>Read More →</div>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
